import { TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';

const NoDataRow = ({ colSpan }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell
        className={classes.noDataCell}
        colSpan={colSpan}
        align="center"
      >
        <Typography className={classes.noDataText}>{t('no_data')}</Typography>
      </TableCell>
    </TableRow>
  );
};

export default NoDataRow;
